import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { InputField } from '../Common/inputField';

class UserName extends Component {
  handleFormSubmit(formProps) {
    this.props.editUserDetail(formProps, formProps.user_permissions, formProps.groups, 2);
  }

  renderResponse() {
    const { editUserDetailSuccess, editUserDetailError, editUserDetailIsLoading } = this.props;
    if (editUserDetailSuccess) {
      return (
        <Row>
          <div className="alert alert-success">
            Success!
          </div>
        </Row>
      );
    } else if (editUserDetailIsLoading && !editUserDetailError) {
      return (
        <Row>
          <div className="alert alert-info">
            ...<Translate value="reading_data" />
          </div>
        </Row>
      );
    } else if (editUserDetailError) {
      return (
        <Row>
          <div className="alert alert-danger">
            {editUserDetailError}
          </div>
        </Row>
      );
    }
  }

  render() {
    const { handleSubmit, editUserDetailSuccess } = this.props;
    return (
      <div>
        <Row>
          <Col xs={12} style={{ marginTop: '20px' }}>
            <Col xs={4}>
              <label style={{ float: 'right', paddingTop: '2px' }}>
                <Translate value="user_name" />
              </label>
            </Col>
            <Col xs={5} style={{ float: 'left' }}>
              <Field name="username" component={InputField} />
            </Col>
          </Col>
        </Row>
        <Row style={{ marginTop: '80px', textAlign: 'center' }}>
          <button onClick={handleSubmit} className="btn btn-primary buttonStyle" >
            <em className="fa fa-check" />
            <Translate value="submit" />
          </button>
        </Row>
        <br />
        {this.renderResponse()}
      </div>
    );
  }
}

export default UserName;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/userName.jsx